class HeaderLogo extends HTMLElement {
  connectedCallback() {
    this.logoEl = this.querySelector('[data-header-logo]');
    this.svg = this.logoEl?.querySelector('svg');

    if (!this.logoEl || !this.svg) {
      return;
    }

    this.endWidth = 136;
    this.ticking = false;
    this.startWidth = this.getStartWidth();

    this.onResize = this.handleResize.bind(this);
    this.onScroll = this.handleScroll.bind(this);

    window.addEventListener('resize', this.onResize, { passive: true });
    window.addEventListener('scroll', this.onScroll, { passive: true });

    this.update();
    this.logoEl.classList.remove('opacity-0');
    this.logoEl.classList.add('opacity-100');
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.onResize);
    window.removeEventListener('scroll', this.onScroll);
  }

  getStartWidth() {
    if (window.innerWidth >= 1024) {
      return 426;
    }

    if (window.innerWidth >= 768) {
      return 294;
    }

    return 268;
  }

  handleResize() {
    this.startWidth = this.getStartWidth();
    this.update();
  }

  handleScroll() {
    if (!this.ticking) {
      this.ticking = true;
      requestAnimationFrame(this.update.bind(this));
    }
  }

  update() {
    this.ticking = false;

    const scrollY = window.scrollY;
    const viewportHeight = window.innerHeight;
    const scrollProgress = Math.min(1, Math.max(0, scrollY / viewportHeight));

    const width =
      this.startWidth - (this.startWidth - this.endWidth) * scrollProgress;
    this.svg.style.width = width + 'px';

    const logoRect = this.logoEl.getBoundingClientRect();
    const logoMidpoint = logoRect.top + logoRect.height / 2;

    const teaser = document.querySelector('[data-teaser]');

    if (!teaser) {
      this.logoEl.setAttribute('data-scrolled', '');
      return;
    }

    let shouldBeScrolled = false;

    const teaserBottom = teaser.getBoundingClientRect().bottom;

    if (teaserBottom <= logoMidpoint) {
      shouldBeScrolled = true;
    }

    const emailSignup = document.querySelector('[data-email-signup]');

    if (emailSignup) {
      const emailTop = emailSignup.getBoundingClientRect().top;

      if (emailTop <= logoMidpoint) {
        shouldBeScrolled = false;
      }
    }

    if (shouldBeScrolled) {
      this.logoEl.setAttribute('data-scrolled', '');
    } else {
      this.logoEl.removeAttribute('data-scrolled');
    }
  }
}

if (!customElements.get('header-logo')) {
  customElements.define('header-logo', HeaderLogo);
}
